/**
 * Composing <Route> in React Router v6
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 *
 * Upgrading from v5
 * https://reactrouter.com/docs/en/v6/upgrading/v5
 */
import { Routes, Route } from "react-router-dom";

import { Home } from "pages/Home";
import { Login } from "pages/Auth/Login";
import { NotFound } from "pages/NotFound";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import { Register } from "pages/Auth/Register";
import { ForgotPassword } from "pages/Auth/ForgotPassword";
import { NewPassword } from "pages/Auth/ForgotPassword/NewPassword";
import { Onboarding } from "pages/Auth/Onboarding";
import { OnboardingGestor } from "pages/Auth/OnboardingGestor";
import { OnboardingGuard } from "./OnboardingGuard";
import { HomeRedirect } from "./HomeRedirect";
import Profile from "pages/Profile";
import Settings from "pages/Settings";
import Gestao from "pages/Gestao";
import RankingEditor from "pages/Gestao/RankingEditor";
import DisplayMode from "pages/Gestao/DisplayMode";
import { Preview } from "pages/preview";


export const RouteList = () => (
  <Routes>
    {/* Rota raiz - redireciona para home correta baseado no perfil */}
    <Route
      path="/"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <HomeRedirect />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    {/* Rota específica para jogadores (ranking) */}
    <Route
      path="/home"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <Home />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    {/* Rota específica para gestores (painel de gestão) */}
    <Route
      path="/gestao"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <Gestao />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    {/* Rotas de edição/criação de ranking */}
    <Route
      path="/gestao/ranking/novo"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <RankingEditor />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    <Route
      path="/gestao/ranking/editar/:id"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <RankingEditor />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    {/* Rota de modo de exibição (sem menu/navbar) */}
    <Route
      path="/gestao/exibicao"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <DisplayMode />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    <Route
      path="/login"
      element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      }
    />

    <Route
      path="/register"
      element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      }
    />

    <Route
      path="/forgot-password"
      element={
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      }
    />

    <Route
      path="/nova-senha"
      element={
        <PublicRoute>
          <NewPassword />
        </PublicRoute>
      }
    />

    <Route
      path="/onboarding"
      element={
        <PrivateRoute>
          <Onboarding />
        </PrivateRoute>
      }
    />

    <Route
      path="/onboarding/gestor"
      element={
        <PrivateRoute>
          <OnboardingGestor />
        </PrivateRoute>
      }
    />

    <Route
      path="/perfil"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <Profile />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    <Route
      path="/configuracoes"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <Settings />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    <Route
      path="/preview"
      element={
        <PrivateRoute>
          <OnboardingGuard>
            <Preview />
          </OnboardingGuard>
        </PrivateRoute>
      }
    />

    <Route path="*" element={<NotFound />} />
  </Routes>
);
